import { render, staticRenderFns } from "./asistentesMenu.vue?vue&type=template&id=e3508db6&"
import script from "./asistentesMenu.vue?vue&type=script&lang=js&"
export * from "./asistentesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports